<template lang="pug">
pr-wrapper#plugins(fs, :zi="index")
  toast(@activate="activate")
  marquee(@activate="activate")
  keyboard(@activate="activate")
  dropdown(@activate="activate")
  sidepane(@activate="activate")
  interact(@activate="activate")
  messages(@activate="activate")
  popup(@activate="activate")
  sideload(@activate="activate")
  volume(@activate="activate")
</template>

<script>
export default {
  name: "plugins",
  data() {
    return {
      pool: [],
      active: 0,
      mustBeFront: ["sidepane", "interact", "messages", "sideload", "marquee", "toast"],
      isSoftAbort: false
    }
  },
  computed: {
    index() {
      return this.active ? "100" : "100"
    }
  },
  watch: {
    active() {
      this.topLevel()
    }
  },
  mounted() {
    _$.vue.$on("mediaPlaying", () => this.active && this.topLevel())

    __.platform.pluginsSoftAbort = async () => {
      if (!this.pool.length) return true
      const promise = await _$.progress.create()

      const interval = setInterval(() => {
        if (!this.pool.length) {
          clearInterval(interval)
          promise.resolve()
        }
      }, 1000)
      this.softAbort()

      return await promise.done
    }
  },
  methods: {
    topLevel() {
      const mustBeHide = this.mustBeFront.find(comp => this.pool.indexOf(comp) >= 0)
      _$.vue.$emit("toplevel", mustBeHide ? true : false)
    },
    activate(event) {
      if (!event.name && typeof event.state !== "boolean") return false

      if (event.state) {
        if (this.pool.indexOf(event.name) < 0) this.pool.push(event.name)
      } else {
        this.pool = _$.removeFromArray(this.pool, event.name)
        if (this.isSoftAbort) this.softAbort()
      }

      this.active = this.pool.length
      return true
    },
    async softAbort() {
      if (!this.pool.length) {
        this.isSoftAbort = false
      } else {
        this.isSoftAbort = true
        _$.vue.$emit(this.pool[this.pool.length - 1], "skip")
        return true
      }
    }
  }
}
</script>
